import { FormHeader, FormItem } from '@scts-ui/component-library';
import { Party } from '@scts/models';
import AddressComponent from './address';

export interface RepProps {
  rep: Party;
}

const Representative = (repProps: RepProps) => {
  return (
    <div className="d-flex flex-column flex-lg-row flex-wrap">
      <div className="card-body">
        <FormHeader detail={'Representative Details: '} />

        <FormItem
          header={'Company: '}
          detail={repProps.rep.organisation}
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
        />

        {repProps.rep.phoneNumbers.map((phoneNumber, index) => (
          <>
            <FormItem
              header={'Phone Number:'}
              detail={phoneNumber.number}
              minWidthHeader={'9.7rem'}
              minWidthDetail={'9.7rem'}
              key={index}
              isPhone={true}
            />
            <FormItem
              header={'Phone Type:'}
              detail={phoneNumber.phoneType}
              minWidthHeader={'9.7rem'}
              minWidthDetail={'9.7rem'}
              key={index}
            />
          </>
        ))}

        <FormItem
          header={'Email:'}
          detail={repProps.rep.emailAddress}
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
          isEmail={true}
        />
      </div>
      <AddressComponent address={repProps.rep.address} />
    </div>
  );
};

export default Representative;
